import React from 'react';
import { Link } from 'react-router-dom';
import Photo from './Photo';
import { capSizes } from '../utils/pbImageUrl';
import { getGallery } from '../utils/imageScanner';

function CollectionCard({ category, priority }) {
  // Start loading the collection as soon as a finger or pointer lands on it.
  const prefetch = () => getGallery(category.slug).catch(() => {});

  return (
    <Link
      to={`/gallery/${category.slug}`}
      onPointerEnter={prefetch}
      onTouchStart={prefetch}
      className="reveal group relative block aspect-[4/5] overflow-hidden rounded-xl bg-base-200 transition-transform duration-200 active:scale-[0.98] sm:aspect-[3/4]"
    >
      <Photo
        cover
        src={category.cover_image_url}
        srcSet={category.cover_srcset}
        sizes={capSizes('(min-width: 1152px) 370px, (min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw')}
        alt={category.name}
        priority={priority}
        className="transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-5 pt-24 text-left text-white">
        <h2 className="text-2xl font-semibold tracking-tight">{category.name}</h2>
        {category.description && (
          <p className="mt-1 line-clamp-2 text-sm text-white/85">{category.description}</p>
        )}
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium">
          View collection
          <span aria-hidden="true" className="transition-transform group-hover:translate-x-1">→</span>
        </span>
      </div>
    </Link>
  );
}

export default CollectionCard;
